import { render } from "./SystemSettingsList.vue?vue&type=template&id=080ad6fa&scoped=true"
import script from "./SystemSettingsList.vue?vue&type=script&lang=ts"
export * from "./SystemSettingsList.vue?vue&type=script&lang=ts"

import "./SystemSettingsList.vue?vue&type=style&index=0&id=080ad6fa&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-080ad6fa"

export default script